import { Box, List, Button, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import DrawerComponent from "./Dashboard/Dashboard-Component/DrawerComponent";
import usePathStyles from "./Report/src/Component/Share/usePathStyles";
export default function ProductAndCategoryPath() {
  const classes = usePathStyles();
  const history = useHistory();
  return (
    <Box className={classes.container}>
      <DrawerComponent onReport />
      <Typography className={classes.title} variant="h2" align="center">
        Product and Category
      </Typography>
      <List>
        {[
          ["Categories", "product/category"],
          ["Subcategories", "product/subcategory"],
          ["Products", "product/product"],
        ].map((text, _) => (
          <Box>
            <Button
              variant={"outlined"}
              className={classes.button}
              onClick={() => {
                history.push({
                  pathname: "/bi/report/" + text[1],
                });
              }}
            >
              {text[0]}
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}
